
export default {
  props: {
    showOptions: {
      type: Object,
      default: () => {
        return {
          gallery: true,
          selfie: true,
          video: true,
        };
      },
    },
    initTab: {
      type: String,
      default: "gallery",
    },
  },

  data() {
    return {
      currentElem: "gallery",
    };
  },

  mounted() {
    this.clickTab({ target: { name: this.initTab } });
  },

  methods: {
    clickTab({ target }) {
      this.currentElem = target.name;
      this.$emit("changeTab", `profile-${target.name}`);
    },
  },
};
